export default __webpack_public_path__ + "static/media/product.8d0899bd.svg";